import { Component, OnInit, Output, OnDestroy, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { debugToConsole } from '../shared/dev/debug-operator';

import { LoginService, Profile } from '../core/auth';

import { Settings, SettingsService } from '../settings';
import { UserService } from '../core/data/user.service';
import { FileSaverService } from '../core/data/file-saver.service';

import { Direction } from '../shared/layout/header/sticky-header.directive';
import { FilterModel } from '../models';

import { routableComponents } from '../routing/app-routing.module';

@Component({
  selector: 'lud-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  isDevDebug: boolean;

  routableComponents = routableComponents;

  private subscription: Subscription;
  useIdentityServer: boolean;

  // private isAuthorizedSubscription: Subscription = new Subscription();
  // public isAuthorized: boolean = false;
  public isDevTest: boolean;
  public isAdmin$: Observable<boolean>;

  // hidden feature
  debugData: any;

  isOpen = true;
  @Output() onSibarOpenEvent = new EventEmitter<boolean>();

  isTopMost = false;
  directionHandler$ = (direction$: Observable<Direction>) =>
    direction$.pipe(
      // debugToConsole("direction$:"),
      tap((event) => {
        this.isTopMost = event === Direction.Down;
      }),
    )

  onPageYOffsetEvent = (args: any) => {
    if (this.isDevDebug) {
      this.debugData = args;
    }
  }

  constructor(
    private readonly loginService: LoginService,
    private readonly userService: UserService,
    private readonly fileSaverService: FileSaverService,
    private settingsService: SettingsService,
    private route: ActivatedRoute
  ) {
    const settings = settingsService.get();
    this.useIdentityServer = settings.useIdentityServer;
    this.isDevTest = settings.showDevMenu;
  }

  ngOnInit() {
    this.isAdmin$ = this.userService.isAdmin; // requestIsAdmin();

    // this.subscription = this.loginService.userProfile$
    //  //.debug("Loading userProfile from sidebar")
    //  .subscribe(userProfile => {
    //
    //    if (userProfile) {
    //      this.isAdmin$ = this.userService.IsAdmin;//requestIsAdmin();
    //    }
    //  });

    this.subscription = this.route.queryParams.subscribe(params => {
      this.isDevDebug = params['isDevDebug'];
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public login() {
    this.loginService.login();
  }

  public logout() {
    this.loginService.logout();
  }

  public get isLoggedIn() {
    return this.loginService.isLoggedIn;
  }

  downloadTest() {
    const filterModel = FilterModel.empty();
    const nowDateValue = new Date();
    const minRangeDate = new Date();
    minRangeDate.setMonth(minRangeDate.getMonth() - 12);

    filterModel.subFleetId = this.settingsService.subFleetId;
    filterModel.dateStart = nowDateValue;
    filterModel.dateEnd = minRangeDate;

    //this.fileSaverService.downloadFile('testReportName', filterModel);
    //
    // this.fileSaverService.downloadFileWithAuth('sampleReportName', filterModel).subscribe(
    //  (response) => {
    //    console.log('OK');
    //
    //    //const blob = new Blob([response], { type: 'text/csv' });
    //    //const url = window.URL.createObjectURL(blob);
    //    //window.open(url);
    //
    //    //const fileName = this.fileSaverService.getFilenameFromResponse(response);
    //    //FileSaver.saveAs(response.blob(), fileName);
    //  },
    //  (error) => console.log(error)
    // );
  }
}
